<template>
  <div class="outer-container">
    <!-- Heading Area -->
    <div v-show="getResults.length > 0">
      <div class="row">
        <div class="col-9 text-center">
          <p style="line-height: 35px;" class="text-left pl-4">
            Click on any column header to sort on that column. Click again to reverse order.
          </p>
        </div>

        <div class="col form-group form-inline">
          <span class="mr-1">Show </span>
          <select name="recordsperpage" v-model="pageSize" @change="handlePageSize" class="form-control">
            <option value="10">10</option>
            <option value="15">15</option>
            <option value="20">20</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100" selected="">100</option>
            <option value="200">200</option>
            <option value="500">500</option>
            <option value="1000">1000</option>
          </select>
          <span class="ml-1"> entries</span>
        </div>
      </div>
      <!-- Heading Area-->

      <!-- Table Area -->
      <div class="table-responsive">
        <table class="table table-striped border">
          <thead>
            <tr scope="row">
              <th scope="col" style="cursor:pointer;" class="min-w" @click="handleSortFieldAndOrder('id')">
                <span>Id</span> <span><font-awesome-icon style="color: #22b1fd;" icon="sort"/></span>
              </th>
              <th scope="col" style="cursor:pointer;" class="min-w" @click="handleSortFieldAndOrder('username')">
                <span>Username</span> <span><font-awesome-icon style="color: #22b1fd;" icon="sort"/></span>
              </th>
              <th scope="col" style="cursor:pointer;" class="min-w" @click="handleSortFieldAndOrder('code')">
                <span>Code</span> <span><font-awesome-icon style="color: #22b1fd;" icon="sort"/></span>
              </th>
              <th scope="col" style="cursor:pointer;" class="min-w" @click="handleSortFieldAndOrder('points')">
                <span>Points</span> <span><font-awesome-icon style="color: #22b1fd;" icon="sort"/></span>
              </th>
              <th scope="col" style="cursor:pointer;" class="min-w" @click="handleSortFieldAndOrder('lastname')">
                <span>Name</span> <span><font-awesome-icon style="color: #22b1fd;" icon="sort"/></span>
              </th>
              <th scope="col" style="cursor:pointer;" class="min-w" @click="handleSortFieldAndOrder('ssn')">
                <span>SSN</span> <span><font-awesome-icon style="color: #22b1fd;" icon="sort"/></span>
              </th>
              <th scope="col" style="cursor:pointer;" class="min-w" @click="handleSortFieldAndOrder('admin')">
                <span>Admin</span> <span><font-awesome-icon style="color: #22b1fd;" icon="sort"/></span>
              </th>
              <th scope="col" style="cursor:pointer;" class="min-w" @click="handleSortFieldAndOrder('locked')">
                <span>Locked</span> <span><font-awesome-icon style="color: #22b1fd;" icon="sort"/></span>
              </th>
              <th scope="col" colspan="4">
                <span>Tools</span>
              </th>
            </tr>
          </thead>

          <!-- data -->
          <UsersTableData />
          <!-- data -->
        </table>
      </div>

      <!-- Table Area -->

      <!-- page Number -->
      <div class="d-flex">
        <div style="flex-grow: 1;" class="pl-2">
          <p>
            Showing {{ (pageNumber - 1) * pageSize + 1 }} to
            {{ totalRecords < pageNumber * pageSize ? totalRecords : pageNumber * pageSize }}
            of {{ totalRecords }} entries
          </p>
        </div>
        <div class="pr-2">
          <pagination
            :data="getResults"
            :totalPages="Math.ceil(totalRecords / pageSize)"
            :total="totalRecords"
            :perPage="getPageSize"
            :currentPage="pageNumber"
            @pagechanged="onPageChange"
          />
        </div>
      </div>
      <!-- page Number -->
    </div>
    <div class="border mb-3" v-show="getResults.length === 0">
      <p class="pt-4 pb-3 text-center">
        There are no user records to display, please select some filters and click search.
      </p>
    </div>
  </div>
</template>

<script>
import UsersTableData from './UsersTableData.vue';
import Pagination from '@/components/Pagination.vue';
export default {
  name: 'UsersTable',
  data() {
    return {
      pageSize: 100,
      sortField: '',
      sortOrder: '',
      pageNumber: 1,
    };
  },
  components: {
    UsersTableData,
    pagination: Pagination,
  },
  computed: {
    totalRecords() {
      return this.$store.getters['manageUsers/getTotalRecords'];
    },
    getClients() {
      return this.$store.getters['manageUsers/getClients'];
    },
    getResults() {
      return this.$store.getters['manageUsers/getResult'];
    },
    getPageSize() {
      return this.$store.getters['manageUsers/getPageSize'];
    },
  },
  methods: {
    handlePageSize() {
      this.$store.dispatch('manageUsers/setPageSize', Number(this.pageSize));
      this.$store.dispatch('manageUsers/fetchGetUsers');
    },
    handleSortFieldAndOrder(field) {
      // let SortField = e.target.innerHTML.trim();
      // if (SortField === "Name") {
      //   SortField = "lastname";
      // }
      // this.sortField = SortField.toLowerCase();
      this.sortField = field;
      if (this.sortOrder === '') {
        this.sortOrder = 'ASC';
      } else {
        this.sortOrder = this.sortOrder === 'ASC' ? 'DESC' : 'ASC';
      }
      this.$store.dispatch('manageUsers/setSortFieldAndOrder', {
        sortField: this.sortField,
        sortOrder: this.sortOrder,
      });
      this.$store.dispatch('manageUsers/fetchGetUsers');
    },
    onPageChange(page) {
      console.log('page changed', page);
      this.pageNumber = page;
      try {
        this.$store.dispatch('manageUsers/setPageSize', +this.pageSize);
        this.$store.dispatch('manageUsers/setPageNumber', +this.pageNumber);
        this.$store.dispatch('manageUsers/fetchGetUsers');
      } catch (error) {
        console.log(error);
      }
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.table th {
  padding: 10px 10px !important;
}
.min-w {
  min-width: 100px;
}
</style>
